import { render, staticRenderFns } from "./BasinsSituationByPeriod.vue?vue&type=template&id=4cab597d&scoped=true"
import script from "./BasinsSituationByPeriod.vue?vue&type=script&lang=js"
export * from "./BasinsSituationByPeriod.vue?vue&type=script&lang=js"
import style0 from "./BasinsSituationByPeriod.vue?vue&type=style&index=0&id=4cab597d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cab597d",
  null
  
)

export default component.exports